module.exports = __webpack_public_path__ + "img/IMG_2024_L_WoodMatted_MockedUp.6d68745f.jpg";